/**
 * @file plugin.js
 */

import videojs from 'video.js';
import throttle from "lodash.throttle";

window.flvjs.LoggingControl.enableDebug = false;
window.flvjs.LoggingControl.enableVerbose = false;
const logBufferSpan = false;

const Html5 = videojs.getTech('Html5');
const mergeOptions = videojs.mergeOptions || videojs.util.mergeOptions;
const defaults = {
    mediaDataSource: {},
    config: {}
};

class Flvjs extends Html5 {

    /**
     * Create an instance of this Tech.
     *
     * @param {Object} [options]
     *        The key/value store of player options.
     *
     * @param {Component~ReadyCallback} ready
     *        Callback function to call when the `Flvjs` Tech is ready.
     */
    constructor(options, ready) {
        options = mergeOptions(defaults, options);
        super(options, ready);
    }

    /**
     * A getter/setter for the `Flvjs` Tech's source object.
     *
     * @param {Tech~SourceObject} [src]
     *        The source object you want to set on the `Flvjs` techs.
     *
     * @return {Tech~SourceObject|undefined}
     *         - The current source object when a source is not passed in.
     *         - undefined when setting
     */
    setSrc(src) {
        if (this.flvPlayer) {
            // Is this necessary to change source?
            this.flvPlayer.detachMediaElement();
            this.flvPlayer.destroy();
        }

        const mediaDataSource = this.options_.mediaDataSource;
        const config = this.options_.config;

        mediaDataSource.type = mediaDataSource.type === undefined ? 'flv' : mediaDataSource.type;
        mediaDataSource.url = src;
        this.flvPlayer = window.flvjs.createPlayer(mediaDataSource, config);
        this.flvPlayer.attachMediaElement(this.el_);
        this.flvPlayer.load();

        // 修复无音频流无法播放的问题
        this.flvPlayer.on(window.flvjs.Events.METADATA_ARRIVED, e => {
            let demuxer = this.flvPlayer._transmuxer._controller._demuxer;
            if(!e.audiocodecid) {
                window.console.log("flv NO AUDIO");
                demuxer._hasAudioFlagOverrided = false;
                demuxer._hasAudio = false;
                demuxer._mediaInfo.hasAudio = false;
                // demuxer._onMediaInfo(demuxer._mediaInfo);
            }
        });

        this.handleStark();
    }

    handleStark() {
        if (!this.flvjsInfo) {
            this.flvjsInfo = {};
        }
        const flvPlayer = this.flvPlayer;
        const video = this.el_;
        const resetFlvPlayer = throttle(
            () => {
                try {
                	if(!video.paused) {
                        flvPlayer.unload();
                        flvPlayer.load();
                        flvPlayer.play();
                	}
                } catch (e) {
                    ;
                }
            },
            1000, {
                leading: false
            }
        );

        flvPlayer.on(window.flvjs.Events.RECOVERED_EARLY_EOF, function () {
            console.log("flv ECOVERED_EARLY_EOF", event);
            resetFlvPlayer();
        });
        flvPlayer.on(window.flvjs.Events.ERROR, function (error) {
            console.log("flv ONERROR", error);
            resetFlvPlayer();
        });

        var prevCurrentTime = -1;
        if (this.flvjsInfo.video) {
            this.destroyFlvInfo();
        }
        this.flvjsInfo.video = video;
        this.flvjsInfo.checkTimeoutTmr = setInterval(() => {
            if (flvPlayer.currentTime == prevCurrentTime && prevCurrentTime != 0) {
                console.log("flv timeout resume player! " + video.id);
                resetFlvPlayer();
            } else {
                prevCurrentTime = flvPlayer.currentTime;
            }
        }, 5000);

        video.addEventListener(
            "waiting",
            (this.flvjsInfo.onwaitingfun = function () {
                console.log("###FLV### WAITING ! " + video.id);
            }));

        video.addEventListener(
            "timeupdate",
            (this.flvjsInfo.ontimeupdatefun = function () {
                if (!flvPlayer.buffered.length) return;

                var span =
                    flvPlayer.buffered.end(0) - flvPlayer.currentTime;
                if (span > 10) {
                    video.currentTime = flvPlayer.buffered.end(0) - 1;
                    if (logBufferSpan)
                        console.log("###FLV### SEEK! span" + span + " " + video.id);
                // } else if (span > 3) {
                //     video.playbackRate = 1 + span / 10;
                //     if (logBufferSpan)
                //         console.log(
                //             "###FLV### span" +
                //             span +
                //             ",speed:" +
                //             video.playbackRate +
                //             " " + video.id
                //         );
                // } else if (span < 1) {
                //     video.playbackRate = 1 - (1-span) / 3;
                //     if (logBufferSpan)
                //         console.log(
                //             "###FLV### span" +
                //             span +
                //             ",speed:" +
                //             video.playbackRate +
                //             " " + video.id
                //         );
                } else {
                    video.playbackRate = 1;
                }
            })
        );
    }

    destroyFlvInfo() {
        if (this.flvjsInfo.video) {
            this.flvjsInfo.video.removeEventListener(
                "timeupdate",
                this.flvjsInfo.ontimeupdatefun
            );
            this.flvjsInfo.video.removeEventListener(
                "waiting",
                this.flvjsInfo.onwaitingfun
            );
            clearInterval(this.flvjsInfo.checkTimeoutTmr);
            this.flvjsInfo = {};
        }
    }

    /**
     * Dispose of flvjs.
     */
    dispose() {
        if (this.flvPlayer) {
            this.destroyFlvInfo();
            this.flvPlayer.detachMediaElement();
            this.flvPlayer.destroy();
        }
        super.dispose();
    }

}

/**
 * Check if the Flvjs tech is currently supported.
 *
 * @return {boolean}
 *          - True if the Flvjs tech is supported.
 *          - False otherwise.
 */
Flvjs.isSupported = function () {

    return window.flvjs && window.flvjs.isSupported();
};

/**
 * Flvjs supported mime types.
 *
 * @constant {Object}
 */
Flvjs.formats = {
    'video/flv': 'FLV',
    'video/x-flv': 'FLV'
};

/**
 * Check if the tech can support the given type
 *
 * @param {string} type
 *        The mimetype to check
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */
Flvjs.canPlayType = function (type) {
    if (Flvjs.isSupported() && type in Flvjs.formats) {
        return 'maybe';
    }

    return '';
};

/**
 * Check if the tech can support the given source
 * @param {Object} srcObj
 *        The source object
 * @param {Object} options
 *        The options passed to the tech
 * @return {string} 'probably', 'maybe', or '' (empty string)
 */
Flvjs.canPlaySource = function (srcObj, options) {
    return Flvjs.canPlayType(srcObj.type);
};

// Include the version number.
Flvjs.VERSION = '__VERSION__';

videojs.registerTech('Flvjs', Flvjs);

export default Flvjs;